import { SVGProps } from 'react'

export const CopySvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M128 320v576h576V320H128z m512 512H192V384h448v448z'
        fill='#181818'
      />
      <path
        d='M832 128H384v128h64V192h384v384h-64v64h128V128z'
        fill='#181818'
      />
    </svg>
  )
}
